import Color from 'color'
import styled from 'styled-components'

export const GanttWrapper = styled.div`
  display: flex;
  height: calc(100vh - 135px);
  overflow: auto;
  align-items: flex-start;
  border: 1px solid #e6e8eb;
  border-left: none;
  border-right: none;
`

export const Timeline = styled.div`
  background-color: #fff;
  display: inline-flex;
  border-bottom: 1px solid #e6e8eb;
  flex-grow: 0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 2;
`

export const Week = styled.div`
  &:not(:last-child) {
    border-right: 1px solid #e6e8eb;
  }
`

export const WeekHeader = styled.div`
  text-transform: capitalize;
  height: 24px;
  padding-left: 8px;
  line-height: 24px;
  border-bottom: 1px solid #e6e8eb;
  font-size: 12px;

  .month {
    color: #525b75;
    font-weight: 500;
  }

  .week-number {
    color: #a1a5b0;
  }
`

export const Days = styled.div`
  display: flex;
`

export const DayNumber = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 4px;
`

export const WeekDay = styled.span`
  font-size: 12px;
  text-transform: capitalize;
  color: #a1a5b0;
  line-height: 14px;
`

export const Day = styled.div`
  display: flex;
  width: 55px;
  flex-direction: column;
  height: 50px;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #fdfdfe;

  &:nth-child(7n + 7) {
    width: 54px;
  }

  &:not(:last-child) {
    border-right: 1px solid #e6e8eb;
  }

  &.active {
    background-color: ${props => props.theme.primaryColor};
    color: ${props => props.theme.secondaryFontColor};

    ${WeekDay} {
      color: ${props => props.theme.secondaryFontColor};
    }

    &::before {
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;

      border-top: 8px solid ${props => props.theme.primaryColor};
      position: absolute;
      bottom: -8px;
    }
  }
`

export const GridRow = styled.div`
  display: flex;
  height: 52px;
  border-bottom: 1px dashed #e6e8eb;
  overflow: hidden;
`

export const GridCell = styled.div<{ canAdd: boolean }>`
  min-width: 55px;
  position: relative;
  cursor: ${props => (props.canAdd ? 'pointer' : 'initial')};

  &:not(:last-child) {
    border-right: 1px dashed #e6e8eb;
  }

  &.active {
    background-color: ${props => props.theme.primaryColor}0D;
  }

  &.is-weekend {
    background: repeating-linear-gradient(
      -60deg,
      #fff,
      #fff 8px,
      #f3f3f5 8px,
      #f3f3f5 9px
    );

    &.active {
      background: ${props => `repeating-linear-gradient(
        -60deg,
        ${props.theme.primaryColor}0D,
        ${props.theme.primaryColor}0D 8px,
        #f3f3f5 8px,
        #f3f3f5 9px
      )`};
    }
  }
`

export const Event = styled.div<{ color: string; durationDays: number }>`
  position: absolute;
  z-index: 1;
  top: 12px;
  height: 28px;
  border-radius: 4px;
  background-color: ${props => Color(props.color).lightness(99).string()};
  border: 1px solid ${props => props.color};
  color: ${props => props.color};
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
  width: ${props => props.durationDays * 55}px;
  transition: min-width 0.1s ease;
  min-width: 0px;

  &:hover {
    background-color: ${props => Color(props.color).lightness(98).string()};
    cursor: pointer;
    min-width: 100px;
    z-index: 2;
  }

  &.open-start {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.open-end {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.unapproved {
    border-style: dashed;
  }
  &.denied span {
    text-decoration: line-through 2px solid;
  }
  span {
    display: inline-block;
    padding: 6px 8px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

export const Sidebar = styled.div`
  width: 226px;
  flex-shrink: 0;
  position: sticky;
  left: 0;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.04);
  z-index: 3;
  background-color: #fff;
  min-height: 100%;
  border-right: 1px solid #e6e8eb;
`

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  height: 75px;
  background-color: #fdfdfe;
  border-bottom: 1px solid #e6e8eb;
  padding: 0px 16px;
  position: sticky;
  top: 0;
`

export const SidebarElement = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e8eb;
  height: 52px;
  padding-left: 16px;
`

export const PopupBoundary = styled.div`
  position: absolute;
  top: 154px;
  bottom: 0;
  left: 226px;
  right: 0;
  pointer-events: none;
`
